import { useMutation, useQueryClient } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';
import type { TriggerRequestResponse } from '../types/schedulerMonitor';

/**
 * POST /scheduler-monitor/batch/jobs/{jobName}/trigger — 수동 트리거 (SCHEDULER_TRIGGER)
 * 성공 시 batch-jobs + batch-executions 쿼리 invalidate.
 */
export function useTriggerJob() {
  const queryClient = useQueryClient();

  return useMutation<
    TriggerRequestResponse,
    { code: string; message: string; traceId?: string },
    { jobName: string; params?: Record<string, string> }
  >({
    mutationFn: ({ jobName, params }) =>
      schedulerMonitorApi.triggerBatchJob(jobName, params),
    onSuccess: (_data, { jobName }) => {
      void queryClient.invalidateQueries({
        queryKey: ['scheduler-monitor', 'batch-jobs'],
      });
      void queryClient.invalidateQueries({
        queryKey: ['scheduler-monitor', 'batch-executions', jobName],
      });
    },
  });
}
